import { render } from "./InvoicingForm.vue?vue&type=template&id=37579623"
import script from "./InvoicingForm.vue?vue&type=script&lang=js"
export * from "./InvoicingForm.vue?vue&type=script&lang=js"

import exportComponent from "/Users/francois/WebstormProjects/crema-manager-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__